import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ApolloClient, HttpLink } from "@apollo/client";
import { ApolloLink } from "@apollo/client/link/core";
import { onError } from "@apollo/client/link/error";
import { useMemo } from "react";
// BatchHttpLinkを使うとPersistedQueryのGETリクエストが使えない
// import { BatchHttpLink } from "@apollo/client/link/batch-http";
import cache from "@/apollo/cache/index";
import createDataSources from "@/apollo/datasources/index";
import { AUTH_LOGOUT_MUTATION, AUTH_USER } from "@/apollo/queries/user";
import schema from "@/apollo/schemas/index";
import routes from "@/lib/routes";
import { createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
import { RetryLink } from "@apollo/client/link/retry";
import { SchemaLink } from "@apollo/client/link/schema";
import { sha256 } from "crypto-hash";
let apolloClient;

// ユーザーと選択しているプロフィールののratingでキャッシュされるようにextensionsに値をいれる
const AddExtensionsLink = new ApolloLink((operation, forward) => {
  const {
    cache
  } = operation.getContext();
  const user = cache.readQuery({
    query: AUTH_USER
  });
  if (user) {
    var _user$user, _user$user2;
    operation.extensions.user = {
      uuid: user === null || user === void 0 || (_user$user = user.user) === null || _user$user === void 0 ? void 0 : _user$user.uuid,
      rating: user === null || user === void 0 || (_user$user2 = user.user) === null || _user$user2 === void 0 || (_user$user2 = _user$user2.currentProfile) === null || _user$user2 === void 0 ? void 0 : _user$user2.rating
    };
  }
  return forward(operation);
});
// SSRとCSRでリンクを変える
function createIsomorphLink() {
  let req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (false) {
    return new SchemaLink({
      schema,
      context: () => {
        const dataSources = createDataSources({
          req
        });
        const context = {
          req,
          res,
          dataSources
        };
        Object.values(dataSources).forEach(dataSource => {
          if (dataSource.initialize) {
            dataSource.initialize({
              context
            });
          }
        });
        return context;
      }
    });
  } else {
    const logout = async () => {
      const client = initializeApollo();
      // cookieからトークンを削除するためにlogoutをコールする
      await client.mutate({
        mutation: AUTH_LOGOUT_MUTATION,
        variables: {
          force: true
        }
      });
      await client.clearStore();
      window.location.replace(routes["401"]);
    };
    return ApolloLink.from([onError(_ref => {
      let {
        graphQLErrors,
        networkError
      } = _ref;
      if (graphQLErrors) {
        graphQLErrors.forEach(async _ref2 => {
          var _extensions$response;
          let {
            message,
            location,
            path,
            extensions
          } = _ref2;
          console.log(`[GraphQL Error] Message: ${message}, location: ${location}, path: ${path}, extensions: ${JSON.stringify(extensions)}`);
          // authエラーだったら
          // TODO:
          if (message && message.includes("Unauthorized") || (extensions === null || extensions === void 0 || (_extensions$response = extensions.response) === null || _extensions$response === void 0 ? void 0 : _extensions$response.status) == 401 || (extensions === null || extensions === void 0 ? void 0 : extensions.code) === "UNAUTHENTICATED") {
            const client = initializeApollo();
            const {
              data
            } = await client.query({
              query: AUTH_USER,
              fetchPolicy: "network-only"
            });
            const loggedIn = !!(data !== null && data !== void 0 && data.user);
            if (loggedIn) {
              await logout();
            }
          }
        });
      }
      if (networkError) {
        // console.log(networkError.response);
        // console.log(networkError.statusCode);
        // console.log(`[Network Error] ${networkError}`);
        if (networkError.statusCode == 401) {
          logout().then(() => console.log("401 error logout exec"));
        }
      }
    }), new RetryLink({
      delay: {
        initial: 300,
        max: Infinity,
        jitter: true
      },
      attempts: (count, operation, error) => {
        return !!error && operation.operationName != "Subscribe" && operation.operationName != "PurchaseExecute";
      }
    }), createPersistedQueryLink({
      sha256,
      useGETForHashedQueries: true
    }), AddExtensionsLink, new HttpLink({
      uri: "/api/graphql",
      credentials: "same-origin"
    })]);
  }
}
export function createApolloClient() {
  let req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const client = new ApolloClient({
    ssrMode: false,
    cache: cache(),
    link: createIsomorphLink(req, res),
    ssrForceFetchDelay: 100,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
      }
    },
    useGETForQueries: true,
    resolvers: {
      DeviceInfo: {
        isWebView: parentObj => {
          if (true) {
            const queryString = [...new URLSearchParams(window.location.search).entries()].reduce((obj, e) => {
              return _objectSpread(_objectSpread({}, obj), {}, {
                [e[0]]: e[1]
              });
            }, {});
            if (queryString !== null && queryString !== void 0 && queryString.in_app || parentObj.isApp) {
              return true;
            }
          }
          return parentObj.isApp;
        }
      }
    }
  });
  return client;
}
export function initializeApollo() {
  var _apolloClient2;
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const _apolloClient = (_apolloClient2 = apolloClient) !== null && _apolloClient2 !== void 0 ? _apolloClient2 : createApolloClient(req, res);
  if (initialState) {
    const existingCache = _apolloClient.extract();
    _apolloClient.cache.restore(_objectSpread(_objectSpread({}, existingCache), initialState));
  }

  // For SSG and SSR always create a new Apollo Client
  if (false) return _apolloClient;
  // Create the Apollo Client once in the client
  if (!apolloClient) apolloClient = _apolloClient;
  return _apolloClient;
}
export function useApollo(initialState) {
  const store = useMemo(() => initializeApollo(initialState), [initialState]);
  return store;
}